module.exports = __webpack_public_path__ + "static/media/accounting.b553fc25.png";